import React, { useEffect, useState } from "react";
import Banner from "./components/Banner/Index";
import Title from "./components/Title/Index";
import "./components/Accordions/index.css";
import WebContainer from "./components/WebContainer/Index";
import BusinessEnquiry from "./components/Forms/BusinessEnquiry";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import { API_BASE_URL } from "./Utils/useApi";

const Career = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setloading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/career.php`);
        setPageData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setloading(false);
      }
    };
    fetchData();
  }, []);
  if (loading)
    return (
      <div className="preloader flex-center">
        <CircularProgress size={24} />
      </div>
    );
  if (error) return <div>Error: An error occurred while fetching data</div>;
  if (!pageData) return null;
  const { bannerData, overview } = pageData;
  return (
    <main>
      {bannerData && <Banner Data={bannerData} />}
      {overview && (
        <WebContainer
          _parentClass="Overview"
          containerClass={"position-relative "}
        >
          <div className="col-12 float-start position-relative">
            <Title
              firstHeading={overview.Title}
              secondHeading={overview.subTitle}
              subTitle={overview.descp}
              _class={'text-lg-center text-start'}
              headingOne={true}
            />
          </div>
        </WebContainer>
      )}  
     
      <BusinessEnquiry />
    </main>
  );
};

export default Career;
